import { api } from './operations.generated';
import { usersOGService } from '../users/rtkquery/users.og';
import { getLogger } from '../../libs/logger';

const logger = getLogger('roomApi');
/**
 * Enhanced room API with cache update logic.
 * Updates the GetRoomsForUser GraphQL cache and invalidates the REST rooms cache
 * after a successful UpdateRoom mutation so the UI reflects changes immediately.
 */
export const roomApi = api.enhanceEndpoints({
  endpoints: {
    UpdateRoom: {
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          // Update GraphQL GetRoomsForUser cache with the updated room data
          dispatch(
            api.util.updateQueryData('GetRoomsForUser', undefined, (draft) => {
              const roomEdge = draft.Room?.getRoomsForUser?.edges?.find(
                (edge) => edge.node.id === data.updateRoom.id,
              );
              if (roomEdge) {
                Object.assign(roomEdge.node, data.updateRoom);
              }
            }),
          );

          // Invalidate REST rooms cache to force refetch
          // This ensures useRooms/usePersonalRoom hooks get updated data
          dispatch(usersOGService.util.invalidateTags(['rooms']));
        } catch (error) {
          logger.warn('Failed to update room', {
            method: 'onQueryStarted',
            error,
          });
        }
      },
    },
  },
});

export const { useUpdateRoomMutation } = roomApi;
